<div class="disconnected-ribbon-corner shadow">
    <p class="ribbon-main">
        <span>We lost the connection <br />with our mothership.<br />Please <a routerLink="" (click)="reload()">RELOAD</a><br />to ensure everything is up to date.</span>
    </p>
</div>
